module.exports = {"resourceQuery":"?resourcequery","query":"?query","prev":null}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/loaders/queryloader.js?query!?resourcequery
 ** module id = 1
 ** module chunks = 0
 **/